import { TenantPetsData } from "store/tenant/types";
import { getDefaultValue } from "utils/renderTemplates";

/**
 * Determines if a template should be shown based on showHasValue condition.
 */
export function shouldShowByValue(
  template: any,
  handlers: { [key: string]: Function },
  animalType?: string,
  animalIndex?: number,
  stageOnePetsData?: TenantPetsData[]
): boolean {
  if (!template.showHasValue) return true;
  const { field, condition } = template.showHasValue;
  const depFieldName = animalType ? `${animalType}.${field}.${animalIndex}` : field;
  let depValue = handlers.watch ? handlers.watch(depFieldName) : undefined;
  let defaultValue = getDefaultValue(depFieldName, stageOnePetsData ?? []);
  
  // If depValue is undefined/null, check if we have a default value from stageOnePetsData
  if ((depValue === undefined || depValue === null) && (defaultValue !== undefined && defaultValue !== null)) {
    if(depFieldName.includes('choices')){
      let arr: unknown[] = [];
      try {
        arr = JSON.parse(defaultValue);
      } catch (error) {
        arr = [];
      }
      if (Array.isArray(arr)) {
        depValue = arr[0]; // or whatever logic you need
      }
    } else {
      // Use the default value for non-choices fields
      depValue = defaultValue;
    }
  }
  // if (depValue === undefined) depValue = "";
  if (typeof condition === 'string') {
    // Improved regex to handle spaces and single/double quotes, including empty strings
    // Pattern matches: operator + optional quotes + value + optional quotes
    const regex = /(===|!==)\s*(?:(["'])([^\2]*?)\2|(\S+))\s*$/;
    const match = regex.exec(condition);
    if (match) {
      const operator = match[1];
      // match[3] is value inside quotes, match[4] is unquoted value
      const valueStr = (match[3] !== undefined ? match[3] : match[4] || '').trim();
      let compareValue;
      // Handle empty string (with or without quotes)
      if (valueStr === '') compareValue = '';
      else if (valueStr === 'true') compareValue = true;
      else if (valueStr === 'false') compareValue = false;
      else if (!isNaN(Number(valueStr))) compareValue = Number(valueStr);
      else compareValue = valueStr;
      
      // Normalize depValue: treat undefined/null as empty string for comparison
      const normalizedDepValue = (depValue === undefined || depValue === null) ? '' : depValue;
      
      if (operator === '===') {
        return normalizedDepValue === compareValue;
      } else if (operator === '!==') {
        return normalizedDepValue !== compareValue;
      }
    }
  }
  return true;
}